<template>
  <div>
    <header>
      <Header msg="Header" />
      <div class="searchbar">
        <div class="container">
          <div class="searchbar_box flex_center">
            <button>
              <i class="icon-search"></i>
            </button>
            <!-- <input type="text" placeholder="輸入店名或地址搜尋" ref="delivery_address" /> -->
            <input
              type="text"
              placeholder="輸入地址搜尋"
              ref="delivery_address"
              v-model="inputAddr"
            />
            <button
              class="gps_btn"
              v-on:click="nearBySearch()"
              v-click-outside="hideAutocomplete"
            >
              <i v-show="!gpsLoading" class="icon-gps"></i>
              <div v-show="gpsLoading" class="loader"></div>
            </button>
          </div>
        </div>
        <div class="autocomplete gps_click" v-show="gpsReason">
          <div class="group">
            <p class="label">
              {{ $t(gpsReason) }}
            </p>
          </div>
        </div>
      </div>
    </header>
    <main>
      <Banners />
      <nav class="tabs store">
        <div class="container">
          <a
            href="#"
            v-on:click="selectedCategory = 'all'"
            :class="[selectedCategory === 'all' ? 'current' : '']"
            >全部</a
          >
          <a
            href="#"
            v-on:click="selectedCategory = 'history'"
            :class="[selectedCategory === 'history' ? 'current' : '']"
            >曾點過</a
          >
        </div>
      </nav>
      <div v-if="loading" class="loading_area flex_center">
        <div class="loader"></div>
        <div>loading..</div>
      </div>

      <div
        v-if="
          !shops || !shops[selectedCategory] || !shops[selectedCategory].length
        "
        class="page_notfound container flex_center flex_wrap"
      >
        <section>
          <div class="icon-notfound"></div>
          <div>
            <b>{{
              inputAddr
                ? "此地址找不到符合的店家，請重新輸入"
                : "請輸入地址開始搜尋店家"
            }}</b>
          </div>
          <!--<div>找不到符合的店家</div>-->
        </section>
      </div>
      <div class="storelist image_s container flex_top flex_wrap">
        <a
          v-for="(shop, index) in shops[selectedCategory]"
          :key="index"
          class="flex_center flex_wrap"
          v-on:click="openShop(shop.id)"
        >
          <div class="cover">
            <img :src="shop.image ? shop.image : defaultImage" />
            <div v-if="!shop.isEnabled" class="cover_mask flex_center">
              暫不供應
            </div>
            <!-- 暫不供應的圖片加遮罩 -->
          </div>
          <div class="info">
            <div class="name">{{ shop.name }}</div>
            <div class="add">
              {{ shop.address }}
              <span class="km"
                >({{
                  shop.distance ? shop.distance.toFixed(2) + " km" : ""
                }})</span
              >
            </div>
          </div>
          <div class="focus">
            <!-- <div class="comment"><i class="icon-star"></i> 4.5</div> -->
            <!--<div :class="['status', shop.isEnabled ? '' : 'stop-open']">
              {{ shop.isEnabled ? "營業中" : "暫不供應" }}
            </div>-->
            <!--<time :class="[shop.isEnabled ? '' : 'visible_hide']"
              >{{ shop.waitingHumanTime }}{{ shop.waitingHumanUnit }}</time
            >-->
          </div>
          <div class="iconbar">
            <div class="pick">
              <!-- <i v-if="shop.isDelivery" class="icon_delivery">送</i> -->
              <i v-if="shop.isTakeout" class="icon_hospital">院內送</i>
              <i v-if="shop.isEatIn" class="icon_inside">自取</i>
              <i v-if="shop.isDelivery" class="icon_freight">宅配</i>
            </div>
            <div class="pay">
              <i
                v-if="shop.isMobilePayment && shop.payMethods.linepay"
                class="icon_linepay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.googlepay"
                class="icon_googlepay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.applepay"
                class="icon_applepay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.credit"
                class="icon_creditcard"
              ></i>
               <i
                v-if="shop.isMobilePayment && shop.payMethods.easywallet"
                class="icon_easywallet"
              ></i>
               <i
                v-if="shop.isMobilePayment && shop.payMethods.taiwanpay"
                class="icon_taiwanpay"
              ></i>
                <i
                v-if="shop.isMobilePayment && shop.payMethods.jkopay"
                class="icon_jkopay"
              ></i>
              <i
              v-if="shop.isMobilePayment && shop.payMethods.icashpay"
              class="icon_icash"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.pxpay"
              class="icon_pxpay"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.pxpayplus"
              class="icon_pxpay"
            ></i>
            <i
              v-if="shop.isMobilePayment && shop.payMethods.pluspay"
              class="icon_pluspay"
            ></i>
              <i v-if="shop.isCash" class="icon_cash"></i>
            </div>
          </div>
        </a>
      </div>
      <!-- END .storelist.image_s -->
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Banners from "@/components/Banners.vue";
import { v4 as uuidv4 } from "uuid";
import autocomplete from "autocompleter";
import { authService } from "@/services/auth";
import apis from "@/services/apis";
import moment from "moment";

import Vue from "vue";
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});

export default {
  name: "Togo",
  components: {
    Header,
    Banners,
  },
  data() {
    return {
      loading: false,
      gpsReason: "",
      defaultImage: GLOBAL_DEFAULT_SHOP_IMG,
      gpsLoading: false,
      sessionToken: "",
      selectedCategory: "all",
      shops: {
        all: [],
        history: [],
      },
      inputAddr: "",
    };
  },
  computed: {
    userId() {
      return localStorage.getItem("lineUserId");
    },
    cachedAddress() {
      if (!localStorage.getItem("address")) return null;
      else {
        let addrObj = JSON.parse(
          Base64.decode(localStorage.getItem("address"))
        );
        if (addrObj.placeId) return addrObj;
        else return null;
      }
    },
  },
  methods: {
    openShop(shopId) {
      this.$router.push({
        path: `/shopping/${shopId}`,
        query: this.$router.currentRoute.query,
      });
    },
    hideAutocomplete() {
      // gps如果錯誤訊息打開，要收起來
      $(".autocomplete.gps_click").slideUp();
      // $(".autocomplete.search_focus").slideUp();
      // if (!this.inputAddr.length) {
      //   console.log('the input addr ' + this.inputAddr.length);
      // }
    },
    setAddressInput(addrObj) {
      if (!addrObj) return;
      this.findShops(null, null, addrObj.placeId);
      if (addrObj.mainText && addrObj.secondaryText) {
        // this.inputAddr = `${
        //   addrObj.secondaryText ? addrObj.secondaryText : ""
        // }${addrObj.mainText ? addrObj.mainText : ""}${
        //   addrObj.aptSuiteFloor ? " " + addrObj.aptSuiteFloor : ""
        // }`;

        this.inputAddr = `${addrObj.mainText ? addrObj.mainText : ""}${
          addrObj.aptSuiteFloor ? " " + addrObj.aptSuiteFloor : ""
        }`;
      } else if (addrObj.address) {
        this.inputAddr = addrObj.address;
      }
    },
    nearBySearch() {
      let self = this;
      this.gpsLoading = true;

      if ("geolocation" in navigator) {
        /* geolocation is available */
        navigator.geolocation.getCurrentPosition(
          function(position) {
            console.log(position.coords.latitude, position.coords.longitude);

            // 有點浪費錢，不抓了？
            // getAddress(position.coords.latitude, position.coords.longitude);

            // self.findShops(position.coords.latitude, position.coords.longitude);
            self.findGpsAddress(
              position.coords.latitude,
              position.coords.longitude
            );
            self.gpsLoading = false;
          },
          function(error) {
            console.log("error reason");
            self.gpsReason;
            if (error.code == 1) {
              // 我們無法定位至你目前的位置，請確認你的網路連線以及是否有授權給我們位置資訊。
              self.gpsReason =
                "You've decided not to share your position, but it's OK. We won't ask you again.";
            } else if (error.code == 2) {
              self.gpsReason =
                "The network is down or the positioning service can't be reached.";
            } else if (error.code == 3) {
              self.gpsReason =
                "The attempt timed out before it could get the location data.";
            } else {
              self.gpsReason = "Geolocation failed due to unknown error.";
            }
            $(".autocomplete.gps_click").slideDown();
            self.gpsLoading = false;
          }
        );

        // 不要一直call google api...
        // getLocation();
      } else {
        /* geolocation IS NOT available */
        self.gpsLoading = false;
        $(".autocomplete.gps_click").slideDown();
      }
    },
    findGpsAddress(lat, lng) {
      let self = this;
      return apis
        .getAddressByGps(lat, lng)
        .then(function(addrObj) {
          if (addrObj.placeId) {
            // update address input
            localStorage.setItem(
              "address",
              Base64.encode(JSON.stringify(addrObj))
            );
            self.setAddressInput(addrObj);
            // find shops
            self.findShops(null, null, addrObj.placeId);
          }
        })
        .catch(function(e) {
          console.log("fetch user failed " + e.stack);
        });
    },
    getAddress() {
      let self = this;
      // return fetch(
      //   `${process.env.VUE_APP_APIHOST}/apis/user?user_id=${self.userId}`
      // )
      // .then(res => res.json())
      return apis
        .getUserProfile(self.userId)
        .then(function(responses) {
          if (responses && responses.address) {
            console.log("the responses " + JSON.stringify(responses));
            // self.inputAddr = `${responses.mainText}${
            //   responses.aptSuiteFloor ? " " + responses.aptSuiteFloor : ""
            // }`;

            localStorage.setItem(
              "address",
              Base64.encode(
                JSON.stringify({
                  address: responses.address,
                  mainText: responses.mainText,
                  secondaryText: responses.secondaryText,
                  placeId: responses.placeId,
                  aptSuiteFloor: responses.aptSuiteFloor,
                })
              )
            );
            self.setAddressInput(responses);
            // self.findShops(null, null, responses.placeId);
          } else {
            // get portal suggested shops
            self.getPortalShops(); // 直接抓portal的店
          }
        })
        .catch(function(e) {
          console.log("fetch user failed " + e.stack);
        });
    },
    getHistoryShops() {
      let self = this;
      return fetch(
        `${process.env.VUE_APP_APIHOST}/apis/history-shops?user_id=${self.userId}&p=${self.$router.currentRoute.query.p}`
      )
        .then((res) => res.json())
        .then(function(responses) {
          let hmap = {};

          for (let i = 0; i < responses.length; ++i) {
            if (responses[i]) hmap[responses[i].shopId] = true;
          }

          self.shops.history = [];
          for (let j = 0; j < self.shops.all.length; ++j) {
            if (self.shops.all[j].id && hmap[self.shops.all[j].id.toString()])
              self.shops.history.push(self.shops.all[j]);
          }
        })
        .catch(function(e) {
          console.log("fetch user failed " + e.stack);
        });
    },
    getPortalShops() {
      let self = this;
      return apis.getPortalShops(this.$router.currentRoute.query.p, 'retail')
      .then((response) => {
          let shops = [];
          for (let i = 0; i < response.length; ++i) {
            if (!response[i]) continue;

            response[i].payMethods = {
              linepay: true,
              applepay: true,
              googlepay: true,
              credit: true,
              easywallet: false,
              jkopay: false,
              taiwanpay: false
            };
            if (
              response[i].isMobilePayment &&
              response[i].paymentOptions &&
              response[i].paymentOptions.methods
            ) {
              // 有限制顯示的支付方式
              response[i].payMethods = {};

              for (
                let p = 0;
                p < response[i].paymentOptions.methods.length;
                ++p
              ) {
                response[i].payMethods[
                  response[i].paymentOptions.methods[p]
                ] = true;
              }
            }
            // response[i].waitingTime = parseInt(response[i].waitingTime, 10);
            // let waitingStr = moment
            //   .duration(response[i].waitingTime, "minutes")
            //   .locale("zh-TW")
            //   .humanize();
            // let ss = waitingStr.split(" ");
            // response[i].waitingHumanTime = ss[0];
            // response[i].waitingHumanUnit = ss[1];
            // if (response[i].distance < response[i].maxDistance) {
            //   shops.push(response[i]);
            // }
            shops.push(response[i]);
          }
          self.shops.all = shops;
          self.getHistoryShops();
          self.loading = false;
        })
      .catch(e => {
        console.log('default shops failed ' + e.stack);
      })
    },
    findShops(latitude, longitude, placeId) {
      let self = this;
      self.loading = true;
      return apis.findShops(self.$router.currentRoute.query.p, latitude, longitude, placeId, 'retail')
      // fetch(`${process.env.VUE_APP_APIHOST}/apis/search`, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify({
      //     portal: self.$router.currentRoute.query.p,
      //     latitude: latitude,
      //     longitude: longitude,
      //     placeId: placeId,
      //   }),
      // })
      //   .then((res) => res.json())
        .catch((error) => {
          console.error("Error:", error);
          self.loading = false;
        })
        .then((response) => {
          let shops = [];
          for (let i = 0; i < response.length; ++i) {
            if (!response[i]) continue;

            response[i].payMethods = {
              linepay: true,
              applepay: true,
              googlepay: true,
              credit: true,
              easywallet: false
            };
            if (
              response[i].isMobilePayment &&
              response[i].paymentOptions &&
              response[i].paymentOptions.methods
            ) {
              // 有限制顯示的支付方式
              response[i].payMethods = {};

              for (
                let p = 0;
                p < response[i].paymentOptions.methods.length;
                ++p
              ) {
                response[i].payMethods[
                  response[i].paymentOptions.methods[p]
                ] = true;
              }
            }

            // response[i].waitingTime = parseInt(response[i].waitingTime, 10);
            // let waitingStr = moment
            //   .duration(response[i].waitingTime, "minutes")
            //   .locale("zh-TW")
            //   .humanize();
            // let ss = waitingStr.split(" ");
            // response[i].waitingHumanTime = ss[0];
            // response[i].waitingHumanUnit = ss[1];
            // if (response[i].distance < response[i].maxDistance) {
            //   shops.push(response[i]);
            // }
            shops.push(response[i]);
          }
          self.shops.all = shops;
          self.getHistoryShops();
          self.loading = false;
        });
    },
  },
  mounted() {
    // taiwan default
    // this.changeLanguage("tw");
    // this.changeCurrency("NTD");
    let self = this;

    var input = this.$refs.delivery_address;
    this.sessionToken = uuidv4();
    autocomplete({
      input: input,
      minLength: 1,
      className: "search_focus",
      preventSubmit: true,
      fetch: function(text, update) {
        $(".autocomplete.search_focus").slideDown();
        // text = text.toLowerCase();
        // var suggestions = [
        //   { label: "桃園市平鎮區", value: "Taoyuan" },
        //   { label: "中壢市環中東路", value: "Zongli" },
        //   { label: "平鎮區環南路186", value: "Pingzhen" }
        // ];
        console.log("the text " + text);
        console.log("the sessionToken " + self.sessionToken);
        fetch(
          `${process.env.VUE_APP_APIHOST}/apis/location?s=${encodeURIComponent(
            text
          )}&sessiontoken=${self.sessionToken}`
        )
          .then((res) => res.json())
          .catch((error) => console.error("Error:", error))
          .then((response) => {
            console.log("the response" + JSON.stringify(response));
            let suggestions = [];
            if (!response || !response.results) {
              update(suggestions);
              return;
            }

            for (let i = 0; i < response.results.length; ++i) {
              suggestions.push({
                mainText: response.results[i].mainText,
                value: response.results[i].placeId,
                placeId: response.results[i].placeId,
                secondaryText: response.results[i].secondaryText,
                address: response.results[i].address,
                aptSuiteFloor: response.results[i].aptSuiteFloor,
                group: "地址請輸入至號，樓層可一同輸入",
                // group: self.$t('Street name, apt, suite, floor, etc')
              });
            }
            update(suggestions);
          });
      },
      onSelect: function(item) {
        item.placeId = item.value;
        self.setAddressInput(item);
        self.sessionToken = uuidv4();
        localStorage.setItem("address", Base64.encode(JSON.stringify(item)));
      },
      customize: function(input, inputRect, container, maxHeight) {
        container.style.maxHeight = "50vh";
        container.style.maxWidth = "95%";
        container.style.width = "768px";
        container.style.left = "0";
        container.style.margin = "5px auto";
      },
      render: function(item, currentValue) {
        const itemElement = document.createElement("div");
        itemElement.innerHTML = `
        <p>${item.mainText}${
          item.aptSuiteFloor ? " " + item.aptSuiteFloor : ""
        }</p>
        <p>${item.secondaryText}</p>`;

        return itemElement;
      },
      renderGroup: function(groupName, currentValue) {
        var groupElement = document.createElement("div");
        // groupElement.textContent = groupName;
        groupElement.innerHTML = `<p class="label">${groupName}</p>`;
        return groupElement;
      },
    });

    // if (!this.cachedAddress) this.getAddress();
    // else {
    //   this.setAddressInput(this.cachedAddress);
    // }

    this.subscription = authService.getUserId().subscribe((userId) => {
      console.log("get the sub user id " + JSON.stringify(userId));
      if (!this.cachedAddress) this.getAddress();
      else {
        this.setAddressInput(this.cachedAddress);
      }
    });

    if (!this.cachedAddress) this.getAddress();
    else {
      this.setAddressInput(this.cachedAddress);
    }
  },
  beforeDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  },
};
</script>
<style scoped>
.banner {
  width: 1200px;
  max-width: 100%;
  margin: 10px auto 20px auto;
}
.searchbar .searchbar_box .loader {
  display: block;
}
</style>
